import axios from "axios";
import {showGlobalMessage} from "../components/GlobalMessage/actions/showGlobalMessage";
import {messages as M} from "../../../../_metronic/i18n/messages";

export const FIND_CONTACTS = "/contacts/findContacts";

export const findContacts = (input) => dispatch => {

  return axios.post(FIND_CONTACTS, {input})
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) {
        dispatch(showGlobalMessage('error', M[errorCode]))
      }

      return {options: body.contacts};
    })
    .catch((err) => {
      console.error(err)
      dispatch(showGlobalMessage('error', M['-1']))
    });
};
